export const instructors = [
  {
    id: 1,
    name: '김민준',
    title: '수석 마스터 강사',
    specialty: '반영구 문신 전문',
    career: '15년 경력 | 前 청담 뷰티아카데미 원장',
    quote: '정확한 기술과 예술적 감각을 동시에 갖춘 전문가를 양성합니다. 수강생 한 명 한 명의 성장을 함께합니다.',
    image: 'https://public.readdy.ai/ai/img_res/592346de4acb4b0c76579ea14a0f327f.jpg',
  },
  {
    id: 2,
    name: '이수연',
    title: '마스터 강사',
    specialty: '두피 반영구 문신 전문',
    career: '12년 경력 | 국제 두피문신 자격 보유',
    quote: '두피 반영구 문신은 단순한 기술이 아닌 삶의 자신감을 되찾아주는 예술입니다. 최고의 기술로 최고의 결과를 만들어냅니다.',
    image: 'https://readdy.ai/api/search-image?query=professional%20Korean%20female%20beauty%20instructor%20in%20her%2030s%20wearing%20elegant%20dark%20outfit%2C%20confident%20professional%20expression%2C%20studio%20portrait%20photography%2C%20neutral%20warm%20background%2C%20professional%20headshot&width=400&height=400&seq=inst2&orientation=squarish',
  },
  {
    id: 3,
    name: '박태양',
    title: '마스터 강사',
    specialty: '입술·아이라인 반영구 문신 전문',
    career: '10년 경력 | 입술·아이라인 반영구 전문가',
    quote: '입술과 아이라인 반영구 문신은 일상을 바꾸는 예술입니다. 기초부터 고급 기법까지 체계적으로 가르쳐 드립니다.',
    image: 'https://readdy.ai/api/search-image?query=professional%20Korean%20male%20tattoo%20artist%20instructor%20in%20his%2030s%20with%20artistic%20style%2C%20confident%20expression%2C%20studio%20portrait%20photography%2C%20dark%20moody%20background%2C%20professional%20headshot&width=400&height=400&seq=inst3&orientation=squarish',
  },
];
